import React from 'react';
import type { FC } from 'react';
import { ChangelogProvider } from '../ChangelogProvider';
import { ChangelogContent } from './ChangelogContent';
import { Box, Typography } from '@mui/material';

export const Changelog: FC = () => {
  return (
    <Box sx={{ pt: 3, pb: 3 }}>
      <ChangelogProvider>
        <Typography variant='h5'>Changelog</Typography>
        <ChangelogContent />
      </ChangelogProvider>
    </Box>
  );
};
